<template>
  <div class="info-page">
    <crumbs title="项目管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>项目详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="项目标题" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入项目标题"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="来源" prop="source">
              <el-input
                v-model="form.source"
                placeholder="请输入来源"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="区域" prop="region">
              <province v-model="form.region" placeholder="请选择区域" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="范围" prop="range">
              <enumerate
                url="/api/item/getitemrange"
                v-model="form.range"
                placeholder="请选择范围"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="申报类型" prop="declarationType">
              <enumerate-radio
                url="/api/item/getdeclarationtype"
                v-model="form.declarationType"
                default-value="资金支持类"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="服务类型" prop="serviceType">
              <enumerate-radio
                url="/api/item/getitemservicetype"
                v-model="form.serviceType"
                default-value="科技研发类"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="项目申报周期" prop="publishDate">
              <el-date-picker
                v-model="form.publishDate"
                type="daterange"
                :unlink-panels="true"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="项目内容" prop="content">
              <editor
                v-model="form.content"
                imgUploadUrl="/api/achievement/uploadachiattach"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="是否推荐" prop="isRecommend">
              <el-switch
                v-model="form.isRecommend"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileUploadList">
              <file-upload
                url="/api/policy/uploadpolicyattach"
                :file-list.sync="form.fileUploadList"
                accept=""
                :num-limit="0"
              >
                <el-alert
                  style="margin-top: 10px; line-height: normal"
                  :title="`上传文件格式要求ppt、pdf、doc、docx、txt、xls、xlsx、压缩包；文件名(包含后缀名)的最大长度为100个字符`"
                  type="warning"
                >
                </el-alert>
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "projectInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        name: "",
        source: "",
        region: "",
        range: "",
        declarationType: "",
        serviceType: "",
        publishDate: [],
        content: "",
        isRecommend: 0,
        fileUploadList: [] // attachFiles 相对应
      },
      rules: {
        name: [isEmpty("请输入项目标题")],
        region: [isEmpty("请选择区域", "change")],
        range: [isEmpty("请选择范围", "change")],
        declarationType: [isEmpty("请选择申报类型", "change")],
        serviceType: [isEmpty("请选择服务类型", "change")],
        publishDate: [isEmpty("请选择项目申报周期", "change")],
        content: [isEmpty("请编辑项目内容")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        range,
        declarationType,
        serviceType,
        // list
        publishDate,
        fileUploadList,
        ...others
      } = this.form;
      // 处理时间
      const [startDate = "", endDate = ""] = publishDate || [];
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0] : file;
      };
      const turnFile = {
        attachFiles: fileUploadList
      };
      Object.keys(turnFile).map((key) => {
        turnFile[key] = turnFile[key].map((item) => {
          return deconstruct(item);
        });
      });
      // 处理字符串 转为数字
      const turnNumber = {
        range,
        declarationType,
        serviceType
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile,
        startDate,
        endDate
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        range,
        declarationType,
        serviceType,
        // 时间
        startDate,
        endDate,
        // 去分号
        attachFiles,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        fileUploadList: attachFiles
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] = file === "" ? [] : file;
      });
      // 处理数字 转为字符串
      const turnNumber = {
        range,
        declarationType,
        serviceType
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile,
        publishDate: [startDate, endDate]
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("policy", "addProject", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("policy", "addProject", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("policy", "getProjectInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.model);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/policyManage/projectMessageList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
